"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx3 = _interopRequireDefault(require("clsx"));
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
var _ClickAwayListener = _interopRequireDefault(require("@material-ui/core/ClickAwayListener"));
var _overlayContext = _interopRequireDefault(require("./context/overlayContext"));
var _getImagePos = _interopRequireDefault(require("./utils/getImagePos"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ContentHtml = /*#__PURE__*/(0, _react.lazy)(function () {
  return import("./contentHtml");
});
var ContentIframe = /*#__PURE__*/(0, _react.lazy)(function () {
  return import("./contentIframe");
});
var ContentImages = /*#__PURE__*/(0, _react.lazy)(function () {
  return import("./contentImages");
});
var ContentPrev = /*#__PURE__*/(0, _react.lazy)(function () {
  return import("./contentPrev");
});
var ContentNext = /*#__PURE__*/(0, _react.lazy)(function () {
  return import("./contentNext");
});
var useStyles = function useStyles(_ref) {
  var fullscreen = _ref.fullscreen,
    size = _ref.size,
    noPadding = _ref.noPadding,
    isMobile = _ref.isMobile;
  var maxWidth = null;
  if (typeof size === "number") {
    maxWidth = size;
  }
  if (size === "xsmall") {
    maxWidth = 375;
  }
  if (size === "small") {
    maxWidth = 600;
  }
  if (size === "medium") {
    maxWidth = 700;
  }
  if (size === "large") {
    maxWidth = 980;
  }
  if (size === "xlarge") {
    maxWidth = 1600;
  }
  return (0, _makeStyles.default)(function (theme) {
    var _theme$zIndex;
    return {
      content: {
        background: "#FFFFFF",
        display: "flex",
        flexDirection: "column",
        height: isMobile || fullscreen ? "100%" : "auto",
        maxHeight: isMobile ? "none" : "100%",
        maxWidth: fullscreen ? "none" : maxWidth,
        overflow: "hidden",
        position: "relative",
        width: "100%",
        zIndex: theme === null || theme === void 0 ? void 0 : (_theme$zIndex = theme.zIndex) === null || _theme$zIndex === void 0 ? void 0 : _theme$zIndex.modal
      },
      contentImages: {
        background: "transparent",
        height: "auto",
        maxHeight: "100%",
        maxWidth: "none",
        width: "auto"
      },
      scroll: {
        padding: fullscreen || noPadding ? 0 : theme === null || theme === void 0 ? void 0 : theme.spacing(3, 3, 3),
        overflow: "auto"
      }
    };
  })();
};
var Content = function Content(props) {
  var _useContext = (0, _react.useContext)(_overlayContext.default),
    _useContext2 = _slicedToArray(_useContext, 2),
    overlayProps = _useContext2[0],
    setOverlayProps = _useContext2[1];
  var avoidCloseOnOutsideClickAndESC = overlayProps.avoidCloseOnOutsideClickAndESC,
    classes = overlayProps.classes,
    fullscreen = overlayProps.fullscreen,
    images = overlayProps.images,
    isMobile = overlayProps.isMobile,
    mode = overlayProps.mode,
    nextLabel = overlayProps.nextLabel,
    noPadding = overlayProps.noPadding,
    prevLabel = overlayProps.prevLabel,
    setOpen = overlayProps.setOpen,
    _overlayProps$showNex = overlayProps.showNext,
    showNext = _overlayProps$showNex === void 0 ? false : _overlayProps$showNex,
    _overlayProps$showPre = overlayProps.showPrev,
    showPrev = _overlayProps$showPre === void 0 ? false : _overlayProps$showPre,
    size = overlayProps.size,
    onNext = overlayProps.onNext,
    onPrev = overlayProps.onPrev;
  var css = useStyles({
    fullscreen: fullscreen,
    size: size,
    noPadding: noPadding,
    isMobile: isMobile
  });
  (0, _react.useEffect)(function () {
    function onKeyup(event) {
      if (event.keyCode === 27) {
        setOpen(false);
      }
    }
    if (!avoidCloseOnOutsideClickAndESC) {
      window.addEventListener("keyup", onKeyup);
      return function () {
        return window.removeEventListener("keyup", onKeyup);
      };
    }
  }, [overlayProps, avoidCloseOnOutsideClickAndESC, setOpen]);
  var element = null;
  switch (mode) {
    case "html":
      element = /*#__PURE__*/_react.default.createElement(ContentHtml, null, props.children);
      break;
    case "iframe":
      element = /*#__PURE__*/_react.default.createElement(ContentIframe, null);
      break;
    case "images":
    case "native-images":
      element = /*#__PURE__*/_react.default.createElement(ContentImages, null);
      break;
    default:
      element = null;
  }
  var handleNextClick = function handleNextClick() {
    if (mode === "images" || mode === "native-images") {
      var newIndex = (0, _getImagePos.default)(overlayProps.images, overlayProps.imagesPos, "next");
      setOverlayProps(_objectSpread(_objectSpread({}, overlayProps), {}, {
        imagesPos: newIndex
      }));
    }
    if (onNext) onNext();
  };
  var handlePrevClick = function handlePrevClick() {
    if (mode === "images" || mode === "native-images") {
      var newIndex = (0, _getImagePos.default)(overlayProps.images, overlayProps.imagesPos, "prev");
      setOverlayProps(_objectSpread(_objectSpread({}, overlayProps), {}, {
        imagesPos: newIndex
      }));
    }
    if (onPrev) onPrev();
  };
  if (avoidCloseOnOutsideClickAndESC || showNext || showPrev) {
    return /*#__PURE__*/_react.default.createElement(_react.Suspense, {
      fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx3.default)("mco-overlay-content", css.content, classes === null || classes === void 0 ? void 0 : classes.content, _defineProperty({}, css.contentImages, mode === "images" || mode === "native-images"))
    }, (images && images.length > 1 && !isMobile || showPrev) && /*#__PURE__*/_react.default.createElement(ContentPrev, {
      label: prevLabel,
      onClick: handlePrevClick
    }), element, (images && images.length > 1 && !isMobile || showNext) && /*#__PURE__*/_react.default.createElement(ContentNext, {
      label: nextLabel,
      onClick: handleNextClick
    })));
  }
  return /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
  }, /*#__PURE__*/_react.default.createElement(_ClickAwayListener.default, {
    onClickAway: function onClickAway() {
      setTimeout(function () {
        setOpen(false);
      }, 10);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx3.default)("mco-overlay-content", css.content, _defineProperty({}, css.contentImages, mode === "images" || mode === "native-images"))
  }, images && images.length > 1 && !isMobile && /*#__PURE__*/_react.default.createElement(ContentPrev, {
    label: prevLabel,
    onClick: handlePrevClick
  }), element, images && images.length > 1 && !isMobile && /*#__PURE__*/_react.default.createElement(ContentNext, {
    label: nextLabel,
    onClick: handleNextClick
  }))));
};
var _default = Content;
exports.default = _default;